import {
	SET_PAGE_NOT_FOUND,
} from '../types/appTypes'

export function setPageNotFound(flag) {
	return {
		type: SET_PAGE_NOT_FOUND,
		payload: flag
	}
}